"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Heart = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M11.9999296,18.6832435 L18.3968841,13.2027047 C19.399345,12.4509646 20,11.2763472 20,10 C20,7.790861 18.209139,6 16,6 C14.7252041,6 13.5515568,6.59968438 12.7994935,7.60067478 L12,8.66479439 L11.2005065,7.60067478 C10.4484432,6.59968438 9.27479594,6 8,6 C5.790861,6 4,7.790861 4,10 C4,11.2758119 4.60029193,12.4513474 5.65053456,13.2446288 L11.9999296,18.6832435 Z M12,7 C12.1072944,6.85719202 12.3364905,6.6088455 12.6875885,6.25496042 C13.5696403,5.47417473 14.7294798,5 16,5 C18.7614237,5 21,7.23857625 21,10 C21,11.6372406 20.2130796,13.0906861 18.9968302,14.0027451 L12,20 L5,14.0041055 C3.78692036,13.0906861 3,11.6372406 3,10 C3,7.23857625 5.23857625,5 8,5 C9.2705202,5 10.4303597,5.47417473 11.3124115,6.25496042 C11.6635095,6.6088455 11.8927056,6.85719202 12,7 Z" })));
};
Heart.displayName = 'Heart';
exports.default = Heart;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Heart.js.map